import { PortfolioImg3 } from "../projectContent/PortfolioImg3";
import { PortfolioImg5 } from "../projectContent/PortfolioImg5";
import { PortfolioImg7 } from "../projectContent/PortfolioImg7";
import { TextQaImg1 } from "../projectContent/TextQaImg1";
import { ProjectNameTitle } from "../projectContent/ProjectNameTitle";
import { PortfolioDescription } from "../projectContent/PortfolioDescription";
import { Link } from "react-router-dom";

export function PortfolioContentOneJustArt() {
  return (
    <section id="intro">
      <div className="container">
        <div className="intro-name">
          <h1 className="buyan">
            TEXT <br></br>
            Q&amp;A
          </h1>
        </div>
        <div id="intro-job-title">
          <ProjectNameTitle
            desc="QUESTION &amp; ANSWERING APP"
            job="DIGITAL DESIGN"
          />
          <div className="standard-project-description">
            <div className="standard-project-half-half-mobile">
              <PortfolioImg7 pic="images/logo.jpg" />
              <span className="standard-project-description-wrap">
                <h6>
                  Having strong digital design skills, I was able to carefully
                  craft a logo that visually represents its core functionality
                  and purpose.
                  <br />
                  <br />
                  The carefully selected shade of blue sets out to communicate
                  innovation and trustworthiness. The shade of aqua for
                  technological modernity, an app that offers a fresh and modern
                  approach to remote question & answers.
                </h6>
              </span>
            </div>
          </div>
          <PortfolioImg3 backgroundPic="images/qa-logo-text-1.jpg" />
          <PortfolioImg5 backgroundPic="images/qa-logo-text-1.jpg" />
          <div className="standard-project-description">
            <div className="standard-project-half-half-mobile">
              <span className="standard-project-description-wrap">
                <h6>
                  The smooth gradient within the logo aims to invoke feelings of
                  ease and effieciency of using the app. It also aims to show
                  the interconnectedness between speaker and audience.
                  <br />
                  <br />
                  The speech bubble placed within the negative space of the logo
                  aims to give some indication of the nature of the app. The
                  logo itself sets out to represent a 'q' and an 'a'
                  simultaneously.
                </h6>
              </span>
            </div>
          </div>

          <div className="visit-project-link">
            <p>
              <a href="https://text-qa.co.uk" target={"_blank"}>
                ←{" "}
                <u>
                  <Link to={"/textqa"}>Back to Project</Link>
                </u>
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
